var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var PostControllerTube = {
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/post/Tube/videoLink/{id}/{tokenId}/{lng?}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @param {string} tokenId
        * @param {string} lng
        * @returns {boolean}
    ******************************************************************************************************/
    GetVideoUsingToken: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/Tube/videoLink/{id}/{tokenId}/{lng?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/TubePost/createFromCMS" and http method "POST" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} targetGroupId
        * @returns {void}
    ******************************************************************************************************/
    CreateFromCMS: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("fileEntryId", JSON.stringify(data.fileEntryId));
        fd.append("targetGroupId", JSON.stringify(data.targetGroupId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/createFromCMS", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/TubePost/neighbors" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<TubePostDownloadDto, string>}
    ******************************************************************************************************/
    GetNeighbors: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("id", JSON.stringify(data.id));
        fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/neighbors", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/post/TubePost/public/{id}/{token}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @param {string} token
        * @returns {TubePostDownloadDto}
    ******************************************************************************************************/
    GetTubePostPublic: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/public/{id}/{token}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/TubePost/{lng}/trie" and http method "GET" to call the back-end.
    
        * @param {string} lng
        * @returns {ExtendedDataCollection<TubePostDownloadDto, Node<string>>}
    ******************************************************************************************************/
    GetTubePostsWithTire: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/{lng}/trie", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/TubePost/views" and http method "POST" to call the back-end.
    
        * @param {string[]} postIds
        * @returns {ViewStats[]}
    ******************************************************************************************************/
    GetPostsViews: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("postIds", JSON.stringify(data.postIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/views", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/TubePost/subtitles/{id}/{lng}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} lng
        * @param {TubePostUploadDto} postDto
        * @param {{[key: string]: File}} subtitle
        * @returns {TubePostDownloadDto}
    ******************************************************************************************************/
    PatchSubTitles: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("postDto", JSON.stringify(data.postDto));
        _.forEach(data.subtitle, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/subtitles/{id}/{lng}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/TubePost" and http method "POST" to call the back-end.
    
        * @param {{[key: string]: File}} thumbnail
        * @param {TubePostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {TubePostDownloadDto}
    ******************************************************************************************************/
    PostTubePost: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        _.forEach(data.thumbnail, function (val, key) { return fd.append(key, val); });
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/TubePost/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {{[key: string]: File}} thumbnail
        * @param {TubePostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {TubePostDownloadDto}
    ******************************************************************************************************/
    PatchTubePost: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        _.forEach(data.thumbnail, function (val, key) { return fd.append(key, val); });
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/TubePost/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/tube/getUploadUrlWithContainer" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @param {string} container
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    GetUploadUriWithContainer: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        if (data.container !== undefined)
            fd.append("container", JSON.stringify(data.container));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/tube/getUploadUrlWithContainer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/tube/getUploadUrl" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    GetUploadUri: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/tube/getUploadUrl", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/PodcastPost/createFromCMS" and http method "POST" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} targetGroupId
        * @returns {void}
    ******************************************************************************************************/
    CreateFromCMSPodCast: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("fileEntryId", JSON.stringify(data.fileEntryId));
        fd.append("targetGroupId", JSON.stringify(data.targetGroupId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/PodcastPost/createFromCMS", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/PodcastPost/neighbors" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<PodcastPostDownloadDto, string>}
    ******************************************************************************************************/
    GetNeighborsPodcast: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("id", JSON.stringify(data.id));
        fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/PodcastPost/neighbors", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/post/PodcastPost/public/{id}/{token}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @param {string} token
        * @returns {PodcastPostDownloadDto}
    ******************************************************************************************************/
    GetPodcastPostPublic: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/PodcastPost/public/{id}/{token}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/PodcastPost/views" and http method "POST" to call the back-end.
    
        * @param {string[]} postIds
        * @returns {ViewStats[]}
    ******************************************************************************************************/
    GetPodcastPostsViews: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("postIds", JSON.stringify(data.postIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/PodcastPost/views", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/PodcastPost/subtitles/{id}/{lng}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {string} lng
        * @param {PodcastPostUploadDto} postDto
        * @param {{[key: string]: File}} subtitle
        * @returns {PodcastPostDownloadDto}
    ******************************************************************************************************/
    PatchSubTitlesPodcast: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("postDto", JSON.stringify(data.postDto));
        _.forEach(data.subtitle, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/PodcastPost/subtitles/{id}/{lng}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/PodcastPost" and http method "POST" to call the back-end.
    
        * @param {{[key: string]: File}} thumbnail
        * @param {PodcastPostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {PodcastPostDownloadDto}
    ******************************************************************************************************/
    PostPodcastPost: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        _.forEach(data.thumbnail, function (val, key) { return fd.append(key, val); });
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/PodcastPost", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/PodcastPost/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {{[key: string]: File}} thumbnail
        * @param {PodcastPostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {PodcastPostDownloadDto}
    ******************************************************************************************************/
    PatchPodcastPost: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        _.forEach(data.thumbnail, function (val, key) { return fd.append(key, val); });
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/PodcastPost/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/post/PodcastPost" and http method "POST" to call the back-end.
    
        * @param {{[key: string]: File}} thumbnail
        * @param {PodcastPostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {PodcastPostDownloadDto}
    ******************************************************************************************************/
    CMSPostPodcastPost: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        _.forEach(data.thumbnail, function (val, key) { return fd.append(key, val); });
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/post/PodcastPost", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/post/PodcastPost/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {{[key: string]: File}} thumbnail
        * @param {PodcastPostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {PodcastPostDownloadDto}
    ******************************************************************************************************/
    CMSPatchPodcastPost: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        _.forEach(data.thumbnail, function (val, key) { return fd.append(key, val); });
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/post/PodcastPost/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PostControllerTube.js.map